import { Time } from "../Helper/Time"
import { WeekConditionsType } from "../Helper/WeekConditions"

export interface WorkPattern {
    wrkptnset_id?: number
    wrkptn_id?: number
    week_conditions: WeekConditionsType
    wrkptn_open?: Time
    wrkptn_close?: Time
}
export interface WorkPatternProps {
    wrkptnset_id: number | string
    wrkptn_id: number | string
    week_conditions: string
    wrkptn_open?: string | null
    wrkptn_close?: string | null
}
export const ObjectToWorkPattern = (obj: WorkPatternProps): WorkPattern => {
    return {
        wrkptnset_id: typeof obj.wrkptnset_id == 'number' ? obj.wrkptnset_id : parseInt(obj.wrkptnset_id),
        wrkptn_id: typeof obj.wrkptn_id == 'number' ? obj.wrkptn_id : parseInt(obj.wrkptn_id),
        week_conditions: obj.week_conditions as WeekConditionsType,
        wrkptn_open: obj.wrkptn_open ? new Time(obj.wrkptn_open) : undefined,
        wrkptn_close: obj.wrkptn_close ? new Time(obj.wrkptn_close) : undefined,
    }
}